import littleGuy from "../../TDD-Images/buddy.png";
import Nav from "./nav";

const bounceAnimation = {
  animation: 'bounce 2s infinite ease-in-out',
  '@keyframes bounce': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '50%': {
      transform: 'translateY(-10px)',
    },
  },
};

const FeedbackLoader = () => {
  return (
    <>
      <Nav />
      <div className="h-[100vh] w-full flex justify-center items-center flex-col gap-8">
        <div className="flex flex-col justify-center items-center gap-4">
          <h1 className="text-[48px] text-[#293056] font-semibold">
            Generating Feedback...
          </h1>
          <p className="text-[#848C96] text-[14px]">
            But while you wait, check out a helpul tip from Buddy below
          </p>
        </div>
        <img 
          src={littleGuy} 
          alt="Buddy" 
          className="w-[241px] animate-float"
        />
        <div className="flex flex-col text-[20px]">
          <p className="m-0 p-0">
            Speak to your experience and{" "}
            <span className="text-[#D26A21]">
              relate it to the job description to
            </span>
          </p>
          <p className="p-0 m-0">
            show that you are a perfect fit for the company
          </p>
        </div>
      </div>
    </>
  );
};

export default FeedbackLoader;
